import { token, refresh, logout } from "@/api/auth";
import {
  getToken,
  setToken,
  removeToken,
  setRefreshToken,
  getRefreshToken,
  removeRefreshToken,
} from "@/utils/auth";
import { resetRouter } from "@/router";
import base64url from "base64url";

const getDefaultState = () => {
  return {
    token: getToken(),
    refresh_token: getRefreshToken(),
    role: "",
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.refresh_token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_FIRST_NAME: (state, firstName) => {
    state.firstName = firstName;
  },
  SET_LAST_NAME: (state, lastName) => {
    state.lastName = lastName;
  },
  SET_MEDIA_URL: (state, mediaUrl) => {
    state.mediaUrl = mediaUrl;
  },
  SET_SITE_URL: (state, siteUrl) => {
    state.siteUrl = siteUrl;
  },
  SET_ROLE: (state) => {
    const arr = state.token.split(".");
    const decodeObject = base64url.decode(arr[1]);
    state.role = JSON.parse(decodeObject).role;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();

      params.append("username", username.trim());
      params.append("password", password);
      params.append("grant_type", "password");

      token(params)
        .then((resp) => {
          commit("SET_TOKEN", resp.access_token);
          commit("SET_REFRESH_TOKEN", resp.refresh_token);
          setToken(resp.access_token);
          setRefreshToken(resp.refresh_token);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  refresh({ commit }) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("grant_type", "refresh_token");
      formData.append("refresh_token", getRefreshToken());
      refresh(formData)
        .then((resp) => {
          commit("SET_TOKEN", resp.access_token);
          commit("SET_REFRESH_TOKEN", resp.refresh_token);
          setToken(resp.access_token);
          setRefreshToken(resp.refresh_token);
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          removeToken(); // must remove  token  first
          removeRefreshToken();
          resetRouter();
          commit("RESET_STATE");
          resolve();
        })
        .catch((err) => {
          removeToken(); // must remove  token  first
          removeRefreshToken();
          resetRouter();
          commit("RESET_STATE");
          reject(err);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      removeRefreshToken();
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
